/**
 * @generated SignedSource<<529beb7ea18bd66f2c3b9ed76a459262>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TrainingSourceKind = "knowledge_base" | "web_crawl" | "%future added value";
export type TrainingSourceStatus = "error" | "processing" | "success" | "%future added value";
export type WebCrawlScope = "domain" | "single_page" | "subpath" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TrainingSourceListItemFragment$data = {
  readonly id: string;
  readonly kind: TrainingSourceKind;
  readonly metadata: {
    readonly web_crawl: {
      readonly config: {
        readonly scope: WebCrawlScope;
      };
      readonly requests: ReadonlyArray<string> | null;
    } | null;
  } | null;
  readonly status: TrainingSourceStatus;
  readonly trainingData: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly metadata: {
          readonly web_crawl: {
            readonly title: string | null;
          } | null;
        } | null;
        readonly name: string;
        readonly textContent: string;
        readonly url: string;
      };
    }>;
    readonly totalCount: number;
  };
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"TrainingSourceSettingsFormFragment">;
  readonly " $fragmentType": "TrainingSourceListItemFragment";
};
export type TrainingSourceListItemFragment$key = {
  readonly " $data"?: TrainingSourceListItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TrainingSourceListItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TrainingSourceListItemFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TrainingSourceMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TrainingSourceWebCrawlMetadata",
          "kind": "LinkedField",
          "name": "web_crawl",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WebCrawlConfig",
              "kind": "LinkedField",
              "name": "config",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "scope",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requests",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TrainingDataNodeConnection",
      "kind": "LinkedField",
      "name": "trainingData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TrainingDataNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TrainingData",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "textContent",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TrainingDataMetadata",
                  "kind": "LinkedField",
                  "name": "metadata",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TrainingDataWebCrawlMetadata",
                      "kind": "LinkedField",
                      "name": "web_crawl",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TrainingSourceSettingsFormFragment"
    }
  ],
  "type": "TrainingSource",
  "abstractKey": null
};
})();

(node as any).hash = "58d6470d01f9cdbb89848ace5712eca1";

export default node;
